class httpConfiguratorService{
  /**
   *
   * @param $http
   * @param CONFIG
   */
  constructor(
    $http,
    CONFIG
  ){
    'ngInject';
    this.$http = $http;
    this.CONFIG = CONFIG;
    this.sessionKey = 'X-RapidGAE-Session-User';
  }
  setDefaultsHeaders(){
    let headers = this.$http.defaults.headers;
    let contentType = this.CONFIG.ContentType;
    if( undefined === headers.common['Content-Type']){
      this.$http.defaults.headers.common['Content-Type'] = contentType;
    }
    if( undefined === headers.Accept){
      this.$http.defaults.headers.Accept = contentType;
    }
  }
  setHeaders(token){
    if(undefined === this.$http.defaults.headers.common[this.sessionKey]){
      this.$http.defaults.headers.common[this.sessionKey] = token;
    }
  }
  clearHeaders(){
    delete this.$http.defaults.headers.common[this.sessionKey];
  }
}

export default httpConfiguratorService;


/** WEBPACK FOOTER **
 ** ./frontend/common/services/http.service.js
 **/